















import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    toText() {
      return this.$t('to').toLowerCase()
    },
    hasToText() {
      return this.value.includes(this.toText)
    },
    fromValueText() {
      return this.value.split(this.toText)[0]
    },
    toValueText() {
      return this.value.split(this.toText)[1]
    }
  }
})
